var React = require('react');

function PhoneLocal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.765 13.314l-5.659-1a.666.666 0 00-.707.348l-1.372 2.629a10.68 10.68 0 01-5.442-5.445l2.627-1.372a.666.666 0 00.348-.706l-1-5.658a.666.666 0 00-.283-.437A4.668 4.668 0 000 5.542c.01 8.464 6.869 15.324 15.333 15.333a4.668 4.668 0 003.867-7.279.665.665 0 00-.435-.282zm-3.432 6.228c-7.728-.01-13.99-6.272-14-14a3.334 3.334 0 014.968-2.906l.862 4.884-2.734 1.426a.667.667 0 00-.315.828 12.017 12.017 0 006.987 6.99.667.667 0 00.827-.316l1.427-2.733 4.884.862a3.333 3.333 0 01-2.906 4.965z","fill":"currentColor","fillRule":"nonzero"}));
}

PhoneLocal.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21"};

module.exports = PhoneLocal;

PhoneLocal.default = PhoneLocal;
